import BillPredictionModel from './bill_prediction_model';
export default Backbone.Collection.extend({
  model: BillPredictionModel
});